export enum LayerActionType {
    PUSH = 'push',
    CLOSE = 'close',
    REMOVE = 'remove',
    CONFIRM = 'confirm',
    CLEAR_CONFIRMATION = 'clearConfirmation',
}
